/**
 * Created by neo on 26.02.17.
 */
import React, {Component} from 'react';

type Props = {
  maps: any,
  map: any,
  color?: string,
  origin: {
    lat: number,
    lng: number
  },
  destination: {
    lat: number,
    lng: number
  },
}

export default class Polyline extends Component {

  componentWillUpdate() {
    this.line.setMap(null)
  }

  componentWillUnmount() {
    this.line.setMap(null)
  }

  getPaths() {
    const { origin, destination } = this.props;

    return [
      { lat: Number(origin.lat), lng: Number(origin.lng) },
      { lat: Number(destination.lat), lng: Number(destination.lng) }
    ];
  }

  render() {
    const Polyline = this.props.maps.Polyline;

    const renderedPolyline = this.renderPolyline();
    const paths = { path: this.getPaths() };

    this.line = new Polyline(Object.assign({}, renderedPolyline, paths));

    this.line.setMap(this.props.map);

    return null
  }

  renderPolyline() {
    return {
      geodesic: true,
      strokeColor: this.props.color || '#0000ff',
      strokeOpacity: 1,
      strokeWeight: 4
    };
  }
}



// WEBPACK FOOTER //
// ./src/App/Components/Map/PolyLine.js